import * as React from 'react';
import styled from 'styled-components';

type Props = {
  backupCardAddress:string,
}
export const BackupAddress: React.FC<Props> = (props) => {
  const BackupcardAddressComponent = styled.p`
    color:black;
    font-weight:bold;
  `;
  return (
    <BackupcardAddressComponent id="backupcardaddress">{props.backupCardAddress}</BackupcardAddressComponent>
  );
};